import React from "react";
import SlidingButton from "./SlidingButton";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    root: {
        "& .MuiTypography-root": {
            font: "normal normal normal 14px / 21px Poppins",
        },
    },
});

const options = [
    { key: "yes", value: "Yes" },
    { key: "no", value: "No" },
];

function PINDebit(props) {
    const { onChange, value } = props;
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <SlidingButton
                handleChange={(_e, v) => onChange("pin_debit_default", v)}
                title="Add PIN Debit?"
                value={value}
                options={options}
            />
            {value == "yes" && (
                <Typography>*Ensure PIN Debit pricing is completed.</Typography>
            )}
        </div>
    );
}

export default PINDebit;
